import { useEffect } from 'react';
import { initializeAnalyticsRecovery } from '@/pages/api/v1/utils';

/**
 * Custom hook to initialize and manage analytics event recovery
 *
 * This hook:
 * - Recovers stored critical events from localStorage on mount
 * - Sets up listeners for network online/offline events
 * - Automatically attempts to resend stored events when network is restored
 * - Properly cleans up event listeners on unmount
 *
 * @example
 * ```tsx
 * function App() {
 *   useAnalyticsRecovery();
 *   return <div>...</div>;
 * }
 * ```
 */
export const useAnalyticsRecovery = () => {
  useEffect(() => {
    // Initialize the recovery system and get the cleanup function
    const cleanup = initializeAnalyticsRecovery();

    // Return the cleanup function to be called on unmount
    return cleanup;
  }, []); // Empty dependency array - only run once on mount
};
